import { Skeleton, Table } from 'antd';
import API from 'API';
import { formatVND } from 'general_function';
import React, { useEffect, useState } from 'react'

const columns = [
    { title: "Môn học", key: "course__name", dataIndex: "course__name"},
    { title: "Số tín chỉ", key: "course__credit", dataIndex: "course__credit"},
    { title: "Học phí", key: "total_cost", dataIndex: "total_cost", render: value => formatVND(value) + " ₫"},
    { title: "Kỳ", key: "term__title", dataIndex: "term__title"},
]

export default function Tuition() {
    const [gettingTuition, setGettingTuition] = useState(true);
    const [tuition, setTuition] = useState(null);
    useEffect(() => {
        setGettingTuition(true);
        API.get("/student/get-tuition/")
        .then(res => {
            setGettingTuition(false);
            setTuition(res.data);
        })
        .catch(error => {
            console.log(error);;
        })
    },[])
    return gettingTuition ? <Skeleton active />
    : tuition && <>
        <div>
            <b>Tổng học phí:</b> {formatVND(tuition.total)} ₫
        </div>
        <Table 
            dataSource={tuition.tuition_list}
            columns={columns}
        />
    </>
}
